import { registerStore } from '../../common/utilsClient/multiReducer';

const store = registerStore({
  path: 'ui.screens.ProjectParticipations',
  initialState: {
    dialogs: {},
    filters: [],
  },
});

export default store;
